export var parseFarmerProfile = function (data) {
    var parsedProfile = {
        id: data.id,
        name: data.name,
        species_data: data.species_data,
        location: data.location,
        isVisible: true,
    };
    [
        "summary",
        "logo_img_url",
        "cover_img_url",
        "founded",
        "size",
        "city",
        "state",
        "website_url",
        "contact_email",
        "twitter",
        "instagram",
        "facebook",
    ].forEach(function (key) {
        if (data[key]) {
            parsedProfile[key] = data[key];
        }
    });
    return parsedProfile;
};
//# sourceMappingURL=api-parsers.js.map